export enum PageError {
  NotFound= 'NotFound',
  Sorry= 'Sorry',
}

export type Errors = PageError | null;
